<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row>
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </v-row>
      <v-row class="px-2">
        <v-col cols="12">
          <JobForm />
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
import JobForm from '@/components/JobForm.vue';

export default {
  components: {
    JobForm,
  },
  data() {
    return {
      job: {},
      breadcrumbs: [
        {
          text: 'Dashboard',
          to: '/',
          exact: true,
        },
        {
          text: 'New Job',
          disabled: true,
        },
      ],
    };
  },
};
</script>
